import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Filter from '../Filter';

export default reduxForm({
  form: 'LocalOrderFilter',
})(connect(() => ({
}))((Filter)));
